import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { AppIcon } from '../../app-icon-list/app-icon-list.model';
import { mapProviderToAppIcon } from './provider-list.model';
import { tap } from 'rxjs/operators';
import { getProviderRedirectUrl, mapQueryParamsToProviderRedirectParams } from '../../../../model/domain/user.model';

@Component({
  selector: 'app-providers-list',
  templateUrl: './providers-list.component.html',
  styleUrls: ['./providers-list.component.scss'],
})
export class ProvidersListComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private cidaasService: CidaasService,
    public commonFunc: CommonFunctionsService,
  ) {}

  errorMsg = '';
  icons: AppIcon[] = [];

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const username = params.login_hint || params.userIdHint;
      if (!params.requestId || !params.type || !username) {
        this.errorMsg = 'LOGIN.SELECT_PROVIDERS.BLOCKED.TITLE';
        return;
      }

      this.cidaasService.getUserExistenceForRequestId$({
        requestId: params.requestId,
        loginMethod: params.type,
        username: params.login_hint || params.userIdHint
      })
        .pipe(
          tap(() => this.errorMsg = '')
        )
        .subscribe((result) => {
        if (result && result.action === 'select' && result.providers){
          this.icons = result.providers.map(p => mapProviderToAppIcon(p));
        }else{
          this.errorMsg = 'LOGIN.SELECT_PROVIDERS.BLOCKED.TITLE';
        }
      }, () => {
          this.errorMsg = 'LOGIN.SELECT_PROVIDERS.BLOCKED.TITLE';
        }
      );
    });
  }


  redirectToSelectedProvider(selectedProvider: AppIcon): void {
    const params =
      mapQueryParamsToProviderRedirectParams(this.route.snapshot.queryParams);
    window.location.href = getProviderRedirectUrl(
      selectedProvider.redirectUri,
      params
    );
  }
}
